import React from 'react';
import { Link } from 'react-router-dom';
import { ListHeading, ShowAllButton, PREVIEW_COUNT } from './list-section';

export interface EntityRow {
    id: number;
    name: string;
    href: string;
    badge?: React.ReactNode;
}

interface EntityListProps {
    label: string;
    rows: EntityRow[];
    emptyText: string;
}

export const EntityList = ({ label, rows, emptyText }: EntityListProps) => {
    const [expanded, setExpanded] = React.useState(false);
    const visible = expanded ? rows : rows.slice(0, PREVIEW_COUNT);

    return (
        <div className="flex flex-col">
            <ListHeading label={label} count={rows.length} />
            {rows.length === 0 && (
                <p className="py-3 text-sm text-muted-foreground">{emptyText}</p>
            )}
            {visible.map((row) => (
                <Link
                    key={row.id}
                    to={row.href}
                    className="flex h-10 items-center justify-between gap-3 border-b border-border/60 text-sm hover:text-primary"
                >
                    <span className="flex min-w-0 items-center gap-2">
                        <span className="truncate">{row.name}</span>
                        {row.badge}
                    </span>
                    <span className="shrink-0 text-xs tabular-nums text-muted-foreground">
                        #{row.id}
                    </span>
                </Link>
            ))}
            <ShowAllButton total={rows.length} expanded={expanded} onToggle={() => setExpanded((value) => !value)} />
        </div>
    );
};
